import { render, staticRenderFns } from "./InfoSummary.vue?vue&type=template&id=6ab03537&scoped=true&"
import script from "./InfoSummary.vue?vue&type=script&lang=js&"
export * from "./InfoSummary.vue?vue&type=script&lang=js&"
import style0 from "./InfoSummary.vue?vue&type=style&index=0&id=6ab03537&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab03537",
  null
  
)

export default component.exports